import NavBarLinkItem from 'components/navbar-link/NavBarLinkItem';
import { memo } from 'react';

const BossExpenseSidebarPanel = () => {
  return (
    <div className='sidebar-panel-wrapper !shadow-none border-r border-r-[#E5E9EB] overflow-y-auto h-full'>
      <ul className='sidebar-links-wrapper !shadow-none mt-2 p-3'>
        <NavBarLinkItem
          linkData={{
            path: 'statistic/expense/income-outcome',
            title: 'Kirim va chiqim',
          }}
          iconName='bi bi-arrow-down-up'
          delay={0.1}
        />
      </ul>
    </div>
  );
};

export default memo(BossExpenseSidebarPanel);
